import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const errText = (e, fallback) => formatApiErrorDetail(e.response?.data?.detail) || fallback;

export async function startCardCheckout(payload) {
  const r = await api.post("/payments/stripe/checkout", { ...payload, origin_url: window.location.origin });
  window.location.href = r.data.checkout_url;
}

// The order is created on our server with the exact AUD price and product.
export const paypalCreateOrder = (payload) => async () => {
  try {
    const { data } = await api.post("/payments/paypal/create-order", payload);
    return data.id;
  } catch (e) {
    toast.error(errText(e, "Could not start PayPal. Nothing was charged. Please try again."));
    throw e;
  }
};

// Our server captures the payment and checks it with PayPal before unlocking anything.
export async function paypalCapture(data, actions) {
  try {
    const r = await api.post("/payments/paypal/capture", { order_id: data.orderID });
    const status = r.data.payment_status;
    if (status === "declined") {
      toast.error("PayPal declined that payment method. Please choose another one.");
      return actions.restart();
    }
    if (status === "pending" || status === "capture_pending") {
      toast.info("PayPal is still processing your payment. We'll unlock it automatically as soon as PayPal confirms it.", { duration: 9000 });
      return null;
    }
    return r.data;
  } catch (e) {
    toast.error(errText(e, "Could not confirm your PayPal payment. No access was unlocked."));
    return null;
  }
}

export const paypalCancelled = () =>
  toast("Payment cancelled, nothing was charged.", { description: "You can try again whenever you're ready." });

export const cardError = (e) => toast.error(errText(e, "Could not start checkout. Please try again."));
